'use strict';

import getCookie from 'utils/getCookie';


const SELECTORS = {
    counter: '.js-cart-counter',
    html: 'html',
};

(function () {
    let cartCount = parseInt(getCookie('_bo_basket_count'), 10) + 0;
    // Number.isNaN is not defined in IE10 :P
    cartCount = typeof(cartCount) === 'number' ? cartCount : 0;
    document.querySelectorAll(SELECTORS.counter).forEach(el => {
        el.innerText = cartCount;
    });
    const status = cartCount > 0 ? 'visible' : 'hidden';
    document.querySelector(SELECTORS.html).classList.add(`js-cart-status--${status}`);
}());
